module.exports = __webpack_public_path__ + "static/media/Springs_and_Shocks_White.0963167e.webp";